export const READONLY_DRAFT_AND_AFTER_STATES = new Set([
  'Draft Created',
  'Draft Creation Failed',
  'Awaiting Operator Approval',
  'Approved',
  'Confirmation Failed',
  'Confirmed',
  'Waiting for Acknowledgement',
  'Acknowledgement Failed',
  'Acknowledgement Sent',
  'Done',
  'Closed',
  'Closed - Operator',
  'Rejected',
]);
